module.exports = __webpack_public_path__ + "img/link-logo.a022dbc2.svg";